export default class AppSettings {

    static COOKIE_LIFE_IN_DAYS = process.env.COOKIE_LIFE_IN_DAYS ?? "";

    static REMEMBER_FPU_STORAGE_KEY = "REMEMBER_FPU";

    /**
     * How long after the user is idle that a warning popup should be displayed
     * 
     * @returns {number} 
     */
    static getIdleWarningMilliseconds = (): number => {

        let minutes = Number(process.env.IDLE_WARNING_MINUTES) ?? 30;

        if (Number.isNaN(minutes)) {
            minutes = 30;
        }

        // Convert minutes to milliseconds
        return 1000 * 60 * minutes;

    }

    /**
     * How long after the idle warning popup should be displayed before the user is
     * automatically logged out
     * 
     * @returns {number} 
     */
    static getIdleLogoutMilliseconds = (): number => {

        let minutes = Number(process.env.IDLE_LOGOUT_MINUTES) ?? 1.5;

        if (Number.isNaN(minutes)) {
            minutes = 1.5;
        }

        // Convert minutes to milliseconds
        return 1000 * 60 * minutes;

    }

    /**
     * Gets the standard cookie lifetime in days.
     * @returns 
     */
    static getCookieLifeTime = (): number => {

        let days = Number(AppSettings.COOKIE_LIFE_IN_DAYS);

        if (Number.isNaN(days)) {
            days = 30;
        }

        return days;
    }

    static getPageCacheStaleMinutes = (): number => {
        let minutes = Number(process.env.PAGE_CACHE_STALE_MINUTES) ?? 0;

        if (Number.isNaN(minutes)) {
            minutes = 0;
        }

        return minutes;

    }

    static getGoogleAnalyticsTrackingId = (): string => {

        let trackingId = process.env.GOOGLE_TRACKING_ID;

        if (!trackingId) {
            trackingId = "";
        }

        return trackingId;

    }

    static getRollbarAccessToken = (): string => {
        let accessToken = process.env.ROLLBAR_ACCESS_TOKEN;

        if (!accessToken) {
            accessToken = "";
        }

        return accessToken;
    }

    static getRollbarEnvironment = (): string => {
        let environmentName = process.env.ROLLBAR_ENVIRONMENT;

        if (!environmentName) {
            environmentName = "";
        }

        return environmentName;
    }

}